import React, { memo } from 'react';
import { NodeProps } from 'reactflow';
import useCollapsedLayers from '@components/MainStage/collapsedLayers.store';
import useCollapseController from '@components/MainStage/hooks/useCollapseController';
import { CollapseIcon } from '@components/MainStage/MainStage.styled';
import { UI_SMALL_LAYERS } from '@constants/canvas/general';
import { LayerTypes } from '@constants/canvas/layers';
import useCanvasWidth from '@hooks/canvas/useCanvasWidth';
import { Stack } from '@mui/material';

import { LayerNodeStyled, StyledText } from './LayerNode.styled';

export type NodeData = {
  label: string;
};

export const LayerNode = memo(function LayerNode({
  id,
  data,
}: NodeProps<NodeData>) {
  const isSmall = UI_SMALL_LAYERS.includes(id as LayerTypes);
  const { stripeWidth } = useCanvasWidth();
  const { isCollapsed } = useCollapsedLayers();
  const collapsed = isCollapsed(id as LayerTypes);

  const { handleToggleLayer } = useCollapseController();

  return (
    <LayerNodeStyled id={id} $small={isSmall} $stripeWidth={stripeWidth}>
      <Stack
        direction="row"
        alignItems="center"
        sx={{ cursor: 'pointer' }}
        onClick={(e) => {
          e.stopPropagation();
          handleToggleLayer(id as LayerTypes);
        }}
      >
        <StyledText collapsed={collapsed} variant="h3">
          {data.label}
        </StyledText>

        <CollapseIcon collapsed={collapsed} />
      </Stack>
    </LayerNodeStyled>
  );
});
